import SplitPanelHeader from "./SplitPanelHeader";
import Heading from "./Heading";

export default function Panel({ children, left, right }) {
  return (
    <div
      className="bg-white rounded-md border border-gray-200"
      data-testid={left}
    >
      <SplitPanelHeader left={<Heading>{left}</Heading>} right={right} />
      <div className="pt-4 px-3 sm:px-6 pb-6">{children}</div>
    </div>
  );
}
